export default __webpack_public_path__ + "static/media/icon-coin-trb.f6f161dc.svg";